import React, { useState, lazy, Suspense } from 'react';
import { Button } from '@/components/ui/button';

const OfferRequestForm = lazy(() => import('@/components/OfferRequestForm'));

const content = {
  heading: 'Simplu, clar, fără presiune.',
  subheading: 'Tu ne spui unde locuiești, noi ne ocupăm de tot.',
  steps: [
    { number: '1', title: 'Introduci adresa ', description: 'Completezi adresa și câteva detalii. Durează sub 2 minute.' },
    { number: '2', title: 'Analizăm dacă merită', description: 'Verificăm locația, consumul și acoperișul. Îți spunem sincer dacă investiția are sens.' },
    { number: '3', title: 'Primești oferta optimă', description: 'Comparăm intern ofertele și îți prezentăm cea mai bună variantă — preț, echipamente, instalare.' },
    { number: '4', title: 'Instalare fără griji', description: 'Un instalator verificat ANRE montează sistemul. Solyra coordonează totul.' },
  ],
};

const HowItWorks: React.FC = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);

  return (
    <section className="py-20 md:py-28 bg-foreground">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Header */}
        <div className="grid md:grid-cols-2 gap-6 md:gap-12 mb-16 items-start">
          <h2 className="text-3xl md:text-4xl lg:text-[2.75rem] font-bold leading-tight text-background">
            {content.heading}
          </h2>
          <div className="md:pt-2">
            <p className="text-background/70 text-lg leading-relaxed mb-6">
              {content.subheading}
            </p>
            <Button
              size="lg"
              onClick={() => setIsFormOpen(true)}
              className="bg-accent hover:bg-accent/90 text-accent-foreground px-8"
            >
              Verifică gratuit
            </Button>
          </div>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {content.steps.map((step) => (
            <div key={step.number} className="space-y-4">
              <div className="w-10 h-10 rounded-full border-2 border-accent flex items-center justify-center">
                <span className="text-accent font-bold text-sm">{step.number}</span>
              </div>
              <h3 className="text-xl font-semibold text-background">{step.title}</h3>
              <p className="text-background/60 leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>
      </div>

      {isFormOpen && (
        <Suspense fallback={null}>
          <OfferRequestForm open={isFormOpen} onOpenChange={setIsFormOpen} />
        </Suspense>
      )}
    </section>
  );
};

export default HowItWorks;
